import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {FormControl, FormGroup, Radio} from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {FormattedMessage} from 'react-intl';

import FastModal from '../../components/FastModal';
import FormattedHTMLMessage from '../../components/FormattedHTMLMessage';
import {MessageContainer, SearchUserTable} from '../../components';
import {getMessageBoxContent} from '../../components/MessageBox';
import withIntl from '../../lib/withIntl';
import {showLoading} from '../../stores/actions/appStateAction';
import {
  deleteUserWithoutTransferOwnership,
  deleteUserAndTransferOwnership,
  fetchActiveUsers,
} from '../../stores/business/userManagementBusiness';
import {ModalSize, UserRole, UserRoleLevel} from '../../constants/dataEnum';

import './ModalRemoveUser.scss';

function mapDispatchToProps(dispatch) {
  return {
    appStateActionShowLoading: bindActionCreators(showLoading, dispatch),
    userManagementBusinessDeleteUserWithoutTransferOwnership: bindActionCreators(
      deleteUserWithoutTransferOwnership,
      dispatch,
    ),
    userManagementBusinessDeleteUserAndTransferOwnership: bindActionCreators(deleteUserAndTransferOwnership, dispatch),
    userManagementBusinessFetchActiveUsers: bindActionCreators(fetchActiveUsers, dispatch),
  };
}

class ModalRemoveUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      targetUserIds: [],
      userData: [],
      removeConfirmationValue: '',
      selectedRadio: 'option1',
    };
  }

  componentDidMount() {
    this.setState({userData: this.generateUserData()});
  }

  generateUserData = () => {
    const {availableUsers, selectedUserId} = this.props;

    const newUserData = availableUsers
      .filter((item) => item.userId !== selectedUserId && Number(item.userRole) - 1 !== UserRoleLevel.OPERATOR)
      .map((item) => ({
        id: item.userId,
        name: item.username,
        role: UserRole[Number(item.userRole) - 1],
      }));

    return newUserData;
  };

  selectedIdsChange = (selectedIds) => {
    this.setState({targetUserIds: selectedIds});
  };

  removeConfirmationValueChange = (e) => {
    this.setState({removeConfirmationValue: e.target.value});
  };

  onRadioChange = (e) => {
    this.setState({selectedRadio: e.target.value});
  };

  onKeyUpHandler = (e) => {
    if (e.keyCode === 13) {
      if (!this.disabledSaveBtn()) {
        this.confirmRemove();
      }
    }
  };

  renderContent = () => {
    const {userData, removeConfirmationValue, selectedRadio} = this.state;
    const {intl} = this.props;

    const warningMessage = intl.formatMessage({id: 'userManagement.removeUser.message'});
    const content1 = intl.formatMessage({id: 'userManagement.removeUser.content1'});
    const content2 = intl.formatMessage({id: 'userManagement.removeUser.content2'});
    const option1 = intl.formatMessage({id: 'userManagement.removeUser.option1'});
    const option2 = intl.formatMessage({id: 'userManagement.removeUser.option2'});
    const option1Placeholder = intl.formatMessage({id: 'userManagement.removeUser.option1Placeholder'});
    const option2Description = intl.formatMessage({id: 'userManagement.removeUser.option2Description'});
    const searchUserPlaceholder = intl.formatMessage({
      id: 'explorer.ExplorerMenuBarContainer.sendProtocolModal.searchFieldPlaceholder',
    });

    const noDataLabel = (
      <FormattedMessage
        id="explorer.explorerMenuBarContainer.sendProtocolModal.resultEmpty"
        values={{
          // eslint-disable-next-line react/no-unstable-nested-components
          div: (chunks) => (
            <div
              style={{
                color: 'red',
                padding: '30px 10px',
              }}
            >
              {chunks}
            </div>
          ),
        }}
      />
    );

    const column = [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Role',
        accessor: 'role',
      },
    ];

    return (
      <div className="ModalRemoveUser">
        {getMessageBoxContent(warningMessage, MessageContainer.MessageType.WARNING)}
        <span>{content1}</span>
        <br />
        <span>{content2}</span>
        <div className="ModalRemoveUser-checkbox">
          <div style={{width: '90%'}}>
            <FormGroup>
              <Radio name="radio" value="option1" checked={selectedRadio === 'option1'} onChange={this.onRadioChange}>
                {option1}
              </Radio>
              <Radio name="radio" value="option2" checked={selectedRadio === 'option2'} onChange={this.onRadioChange}>
                {option2}
              </Radio>
            </FormGroup>
          </div>
          {selectedRadio === 'option1' && (
            <div style={{paddingTop: '5px'}}>
              <FormControl
                type="input"
                placeholder={option1Placeholder}
                value={removeConfirmationValue}
                onChange={this.removeConfirmationValueChange}
                onKeyUp={this.onKeyUpHandler}
              />
            </div>
          )}
        </div>
        {selectedRadio === 'option2' && (
          <div style={{marginLeft: '20px', marginTop: '-10px'}}>{option2Description}</div>
        )}
        {selectedRadio === 'option2' && (
          <SearchUserTable
            userData={userData}
            searchFieldPlaceholder={searchUserPlaceholder}
            selectedIdsChange={this.selectedIdsChange}
            noDataLabel={noDataLabel}
            columns={column}
          />
        )}
      </div>
    );
  };

  renderContentWithoutSharingConfirmation = () => {
    const {availableUsers, selectedUserId, intl, isOperator} = this.props;
    const selectedUser = availableUsers.filter((item) => item.userId === selectedUserId)[0];
    const name = selectedUser?.username;

    const warningMessage = intl.formatMessage({id: 'userManagement.removeUser.withoutSharingConfirmation.message'});

    const content1 = (
      <FormattedHTMLMessage id="userManagement.removeUser.withoutSharingConfirmation.content1" values={{user: name}} />
    );
    const content2 = (
      <FormattedHTMLMessage id="userManagement.removeUser.withoutSharingConfirmation.content2" values={{user: name}} />
    );
    const contentOperator = (
      <FormattedHTMLMessage id="userManagement.removeUser.operator.content" values={{user: name}} />
    );

    return (
      <div className="ModalRemoveUser">
        {getMessageBoxContent(warningMessage, MessageContainer.MessageType.WARNING)}
        {isOperator ? (
          <p>{contentOperator}</p>
        ) : (
          <span>
            <p>{content1}</p>
            <p>{content2}</p>
          </span>
        )}
      </div>
    );
  };

  disabledSaveBtn = () => {
    const {selectedRadio, targetUserIds, removeConfirmationValue} = this.state;
    const {showSharingConfirmation, isOperator} = this.props;

    if (!showSharingConfirmation || isOperator) {
      return false;
    }

    if (selectedRadio === 'option1' && removeConfirmationValue !== 'REMOVE') {
      return true;
    }

    if (selectedRadio === 'option2' && targetUserIds.length === 0) {
      return true;
    }

    return false;
  };

  confirmRemove = async () => {
    const {userManagementBusinessFetchActiveUsers} = this.props;
    const {selectedRadio, targetUserIds} = this.state;
    const {showSharingConfirmation, onClose, selectedUserId, onActiveUserCallback} = this.props;

    const doFetchActiveUsers = (userIds) => userManagementBusinessFetchActiveUsers(userIds);

    const responseActiveUser = await doFetchActiveUsers([selectedUserId]);

    if (!responseActiveUser) {
      onClose();

      return;
    }

    const activeNames = [];

    for (let i = 0, ii = responseActiveUser.length; i < ii; i += 1) {
      const user = responseActiveUser[i];

      activeNames.push(user.name);
    }

    if (activeNames.length > 0) {
      onClose();
      onActiveUserCallback(activeNames);

      return;
    }

    let response;
    let targetUserId;

    if (!showSharingConfirmation || selectedRadio === 'option1') {
      response = await this.doRemoveUser();
    } else {
      response = await this.doRemoveUser(targetUserIds[0]);
      // eslint-disable-next-line prefer-destructuring
      targetUserId = targetUserIds[0];
    }

    onClose(response, targetUserId);
  };

  doRemoveUser = async (targetUserId) => {
    const {
      userManagementBusinessDeleteUserWithoutTransferOwnership,
      userManagementBusinessDeleteUserAndTransferOwnership,
      selectedUserId,
      intl,
      appStateActionShowLoading,
    } = this.props;

    let loadingMessage;
    let action;

    if (targetUserId) {
      loadingMessage = intl.formatMessage({id: 'userManagement.removeUser.transferProtocolLoading'});
      action = userManagementBusinessDeleteUserAndTransferOwnership;
    } else {
      loadingMessage = intl.formatMessage({id: 'userManagement.removeUser.loading'});
      action = userManagementBusinessDeleteUserWithoutTransferOwnership;
    }

    appStateActionShowLoading(loadingMessage);

    const response = await action(selectedUserId, targetUserId);

    return response;
  };

  render() {
    const {showModal, onClose, intl, showSharingConfirmation, isOperator} = this.props;
    let confirmButton = intl.formatMessage({id: 'userManagement.modalRemoveUser.confirmButton'});
    const cancelButton = intl.formatMessage({id: 'userManagement.modalRemoveUser.cancelButton'});

    if (!showSharingConfirmation) {
      confirmButton = intl.formatMessage({
        id: 'userManagement.modalRemoveUser.withoutSharingConfirmation.confirmButton',
      });
    }

    this.btnAction = [
      {text: confirmButton, style: 'primary', handlerClick: this.confirmRemove, disabled: this.disabledSaveBtn()},
      {text: cancelButton, style: 'secondary', handlerClick: () => onClose(false)},
    ];

    return (
      <FastModal
        header={intl.formatMessage({id: 'userManagement.modalRemoveUser.modalHeader'})}
        content={
          showSharingConfirmation && !isOperator ? this.renderContent() : this.renderContentWithoutSharingConfirmation()
        }
        btnAction={this.btnAction}
        show={showModal}
        className="ModalRemoveUser-modal"
        isValid
        onClose={() => onClose(false)}
        closeDisabled
        backdrop={false}
        size={ModalSize.LARGE}
      />
    );
  }
}

ModalRemoveUser.propTypes = {
  appStateActionShowLoading: PropTypes.func.isRequired,
  userManagementBusinessDeleteUserWithoutTransferOwnership: PropTypes.func.isRequired,
  userManagementBusinessDeleteUserAndTransferOwnership: PropTypes.func.isRequired,
  userManagementBusinessFetchActiveUsers: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  selectedUserId: PropTypes.any,
  availableUsers: PropTypes.array,
  showSharingConfirmation: PropTypes.bool,
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  onActiveUserCallback: PropTypes.func,
  isOperator: PropTypes.bool.isRequired,
};

ModalRemoveUser.defaultProps = {
  selectedUserId: null,
  availableUsers: [],
  showSharingConfirmation: true,
  showModal: false,
  onClose: () => {},
  onActiveUserCallback: () => {},
};

export default connect(null, mapDispatchToProps)(withIntl(ModalRemoveUser));
